// @flow
import React, { type Node } from 'react';
import { Flex, Text, Button, Divider, Box } from '@locus-taxy/neo-ui';
import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext';
import sendbirdSelectors from '@sendbird/uikit-react/sendbirdSelectors';
import { useChannelContext } from '@sendbird/uikit-react/Channel/context';
import { useTranslation } from 'react-i18next';
import UserProfileImage from '../UserProfileImage';
import MapButton from '../MapButton';
import { isOnline, getRiderId } from 'common/modules/chat/utils/ChatUtils';

type Props = {
    closeMessageWindow: () => void
};

const Header = ({ closeMessageWindow }: Props): Node => {
    const context = useSendbirdStateContext();
    const channelContext = useChannelContext();
    const { t } = useTranslation('liveView');

    const sdkInstance = sendbirdSelectors.getSdk(context);
    const currentUserId = sdkInstance?.currentUser?.userId;

    const { currentGroupChannel: channel } = channelContext;
    const { members } = channel;
    const [user] = members.filter(({ userId }) => userId !== currentUserId);

    const closeChat = () => {
        closeMessageWindow();
    };

    const isUserOnline = user && isOnline(user);
    const riderId = user && getRiderId(user);

    return (
        <Box backgroundColor="white">
            <Flex alignItems="center" p={3}>
                <Button
                    appearance="icon"
                    icon="arrow_left"
                    marginRight={3}
                    onClick={closeMessageWindow}
                />
                <Flex flexGrow={1} alignItems="center">
                    <Box marginRight={3}>
                        <UserProfileImage
                            url={user?.plainProfileUrl}
                            isOnline={isUserOnline}
                            onlineIconSize={6}
                            profileImageSize={24}
                        />
                    </Box>
                    <Text
                        truncated
                        fontSize={3}
                        fontWeight={600}
                        color="grey.600"
                        sx={{ maxWidth: '130px' }}
                    >
                        {user?.nickname ||
                            user?.userId ||
                            t('riderManagerChat.deactivatedUser')}
                    </Text>
                </Flex>
                {riderId && (
                    <Box paddingRight={1}>
                        <MapButton riderId={riderId} />
                    </Box>
                )}
                <Button appearance="icon" icon="cross" onClick={closeChat} />
            </Flex>
            <Divider color="grey.200" />
        </Box>
    );
};

export default Header;
